import axios from "axios";

const http = axios.create({
  baseURL: process.env.VUE_APP_NOTIFICATION_URL,
  timeout: 1200000,
  headers: { "Content-Type": "application/json" }
});

export default http;
